import { PlatformHelper } from '@shared/helpers/platform-helper/platform-helper';

const flag = Symbol();

export abstract class Initializable {
  public initialized = false;
  public constructed = false;

  public abstract initialize(): any;

  public constructor() {
    if (!PlatformHelper.isBrowser()) {
      return;
    }

    Promise.resolve().then(() => {
      this.constructed = true;
    });

    const prototype = Object.getPrototypeOf(this);

    if (prototype[flag]) {
      return;
    }

    prototype[flag] = true;

    const initialize = this.initialize;
    this.initialize = function patchedInitialize() {
      if (this.initialized) {
        throw new Error('Service is already initialized.');
      }

      this.initialized = true;

      const zone = Zone.current.fork({
        name: 'Initialize',
        properties: {
          isInitializing: true,
        },
      });

      return zone.run(() => initialize.apply(this, []));
    };

    const descriptors = Object.getOwnPropertyDescriptors(prototype);

    for (const [propName, descriptor] of Object.entries(descriptors)) {
      if (['constructor', 'initialize'].includes(propName)) {
        continue;
      }

      const value = descriptor.value;

      if (typeof value !== 'function') {
        continue;
      }

      descriptor.value = function (this: any, ...args: any) {
        if (
          this &&
          this.constructed &&
          !this.initialized &&
          !Zone.current.get('isInitializing')
        ) {
          throw new Error(
            `Cannot call "${propName}" of uninitialized "${this.constructor.name}" service.`,
          );
        }

        return value.apply(this, args);
      };
    }

    Object.defineProperties(prototype, descriptors);
  }
}
